import { defaultTheme } from '@nxsys/constants/defaultConfig';
import { AppIconType, Icons } from '@nxsys/types/icons';
import React from 'react';

export type AppViewToggleOption = {
  icon: AppIconType;
  value: string;
};

type Props = {
  value: string;
  onChange: (value: string) => void;
  className?: string;
  options: AppViewToggleOption[];
};

const AppViewToggle: React.FC<Props> = ({
  value,
  onChange,
  className = '',
  options,
}) => {
  const activeColor = defaultTheme.theme.palette.primary[600];
  const inactiveColor = defaultTheme.theme.palette.neutral[500];

  return (
    <div
      className={`flex items-center border border-neutral-200 rounded-[8px] bg-white ${className}`}
    >
      {options.map((option) => {
        const IconComponent = Icons[option.icon as AppIconType];

        return (
          <button
            key={option.value}
            onClick={() => onChange(option.value)}
            className={`flex items-center justify-center w-[36px] h-[36px] rounded-[6px] transition-all ${
              value === option.value
                ? 'border border-primary-600 bg-white shadow-sm'
                : 'border border-transparent bg-transparent'
            }`}
          >
            <IconComponent
              width={18}
              height={18}
              color={value === option.value ? activeColor : inactiveColor}
            />
          </button>
        );
      })}
    </div>
  );
};

export default AppViewToggle;
